import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { usePatients, useHybridPatients } from "@/components/PatientPicker";
import { User, ChevronRight, CalendarDays, Stethoscope, ScanLine, Search } from "lucide-react";

function weeksSince(iso) { try { return Math.floor((Date.now() - new Date(iso)) / 6048e5); } catch { return "—"; } }

export default function Patients() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const filtered = useHybridPatients(q);
  return (
    <Layout title="Patients" subtitle="Cliniko patient cache — open a record to view notes, Clinical Brain & build plans">
      <div className="relative mb-5 max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="patients-search" placeholder="Search patients by name, ID or diagnosis"
          className="w-full rounded-xl border border-slate-200 bg-white py-2.5 pl-9 pr-3 text-sm shadow-sm focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500" />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {filtered.map((p) => (
          <button key={p.cliniko_id} onClick={() => navigate(`/patients/${p.cliniko_id}`)} data-testid={`patient-card-${p.cliniko_id}`}
            className="group rounded-2xl border border-slate-200 bg-white p-5 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-teal-300 hover:shadow-md">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <div className="grid h-11 w-11 place-items-center rounded-xl bg-teal-50 text-teal-600"><User className="h-5 w-5" /></div>
                <div>
                  <div className="font-heading font-bold text-slate-900">{p.name}</div>
                  <div className="font-mono text-[11px] text-slate-400">{p.cliniko_id}</div>
                </div>
              </div>
              <ChevronRight className="h-5 w-5 text-slate-300 transition-transform group-hover:translate-x-0.5 group-hover:text-teal-500" />
            </div>
            <div className="mt-4 flex items-start gap-1.5 text-sm text-slate-600"><Stethoscope className="mt-0.5 h-4 w-4 flex-shrink-0 text-slate-400" />{p.diagnosis}</div>
            <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
              <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-slate-500"><CalendarDays className="h-3 w-3" /> {weeksSince(p.last_visit)}w since visit</span>
              {p.has_active_plan && <span className="rounded-full bg-teal-50 px-2 py-0.5 font-medium text-teal-700">Active plan</span>}
              {p.moti_scan && <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-indigo-600"><ScanLine className="h-3 w-3" /> Moti scan</span>}
            </div>
          </button>
        ))}
      </div>
    </Layout>
  );
}
